import { Spacer } from '../Spacer'

export function PoliticaPrivacidadContent() {
  return (
    <div className="flex flex-col gap-2">
      <h1 className={`w-full px-0 text-h4 text-neutral-900`}>
        POLÍTICA DE PRIVACIDAD
      </h1>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>1. Responsable del tratamiento</h2>
        <div className="flex flex-col gap-2">
          <p>
            <span className="font-bold">Denominación social:</span> Gama Óptima,
            S.L.
          </p>
          <p>
            <span className="font-bold">CIF:</span> B75429340
          </p>
          <p>
            <span className="font-bold">Domicilio social:</span> Ronda General
            Mitre 38-40, Local comercial sótano 1, 08017 Barcelona
          </p>
          <p>
            <span className="font-bold">Correo electrónico de contacto:</span>{' '}
            info@gamaoptima.com
          </p>
          <p>
            Gama Óptima, S.L. (en adelante, "Gama Óptima") es la responsable del
            tratamiento de los datos personales recabados a través del sitio
            web.
          </p>
        </div>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>
          2. Datos personales que recopilamos
        </h2>
        <p>Gama Óptima podrá recopilar los siguientes datos personales:</p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>Datos identificativos: nombre, apellidos</li>
          <li>Datos de contacto: correo electrónico, teléfono</li>
          <li>
            Datos económicos y financieros necesarios para procesos de
            financiación
          </li>
          <li>
            Datos relacionados con solicitudes de información, reservas o
            compras
          </li>
          <li>Datos de navegación (ver Política de Cookies)</li>
        </ul>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>3. Finalidades del tratamiento</h2>
        <p>Los datos personales se tratarán con las siguientes finalidades:</p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>
            Gestionar solicitudes de información realizadas a través de la web
          </li>
          <li>Tramitar reservas, compras y servicios asociados</li>
          <li>Gestionar procesos de financiación solicitados por el usuario</li>
          <li>
            Enviar comunicaciones comerciales relacionadas con nuestros
            productos y servicios (siempre con consentimiento)
          </li>
          <li>
            Mejorar la experiencia de usuario y el funcionamiento de la web
          </li>
          <li>Cumplir con obligaciones legales aplicables</li>
        </ul>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>4. Legitimación del tratamiento</h2>
        <p>La base legal para el tratamiento de los datos es:</p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>El consentimiento del usuario</li>
          <li>
            La ejecución de un contrato o aplicación de medidas precontractuales
          </li>
          <li>El cumplimiento de obligaciones legales</li>
          <li>El interés legítimo de Gama Óptima para mejorar sus servicios</li>
        </ul>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>5. Conservación de los datos</h2>
        <p>
          Los datos personales se conservarán únicamente durante el tiempo
          necesario para cumplir con la finalidad para la que fueron recogidos
          y, posteriormente, durante los plazos legalmente exigidos.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>6. Destinatarios de los datos</h2>
        <p>Los datos podrán ser comunicados a:</p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>Entidades financieras para la gestión de la financiación</li>
          <li>Proveedores de servicios tecnológicos y operativos</li>
          <li>Administraciones públicas cuando exista obligación legal</li>
        </ul>
        <p>
          En ningún caso se cederán datos a terceros con fines comerciales
          ajenos a Gama Óptima.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>7. Derechos del usuario</h2>
        <p>El usuario puede ejercer los siguientes derechos:</p>
        <ul className="ml-6 flex list-disc flex-col gap-2">
          <li>Acceso a sus datos personales</li>
          <li>Rectificación de datos inexactos</li>
          <li>Supresión de sus datos</li>
          <li>Limitación u oposición al tratamiento</li>
          <li>Portabilidad de los datos</li>
        </ul>
        <p>
          Para ejercer estos derechos, puede enviar una solicitud a{' '}
          <span className="font-bold">info@gamaoptima.com</span>, indicando el
          derecho que desea ejercer y adjuntando copia de un documento
          identificativo.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>8. Seguridad de los datos</h2>
        <p>
          Gama Óptima adopta las medidas técnicas y organizativas necesarias
          para garantizar la seguridad, integridad y confidencialidad de los
          datos personales.
        </p>
      </section>
      <Spacer size="32px" />
      <section className="flex w-full flex-col gap-2">
        <h2 className={`text-h4 font-bold`}>
          9. Cambios en la política de privacidad
        </h2>
        <p>
          Gama Óptima se reserva el derecho a modificar la presente Política de
          Privacidad para adaptarla a cambios legislativos o mejoras del
          servicio. Las modificaciones se publicarán en esta misma página.
        </p>
      </section>
    </div>
  )
}
